/**
 * MarketplaceAccessPausedBanner (plan 443) — the app-wide notice for an agent
 * whose marketplace access is paused (verification banned or revoked, which
 * the Home summary folds into `setup.access_paused`).
 *
 * Presentational and stateless: `ProLayout` mounts it once, on every route,
 * when the go-live gate is `on` AND the shared Home store reports
 * `access_paused`. It states an account condition, so it is NOT dismissible.
 *
 * Copy is deliberately neutral: it never names the reason (no "ban",
 * "revoked"), and tells the agent what is unaffected (their buyers and
 * connections) before what is paused.
 */
import { AlertTriangle } from "lucide-react";

const SUPPORT_EMAIL = "support@usesill.com";

export function MarketplaceAccessPausedBanner() {
  return (
    <div
      role="status"
      data-testid="marketplace-access-paused-banner"
      className="flex items-center gap-3 border-b border-warning/30 bg-warning/10 px-4 py-3 text-sm sm:px-8"
    >
      <AlertTriangle
        aria-hidden="true"
        className="h-4 w-4 flex-shrink-0 text-warning"
      />
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-fg">Marketplace access paused</p>
        <p className="mt-0.5 text-fg-muted">
          You keep all your buyers and connections. Marketplace requests and
          offers are paused for now.{" "}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="font-semibold text-pro underline"
          >
            Contact support
          </a>
        </p>
      </div>
    </div>
  );
}
